/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Volume_BeforeInputs */

const en_ui_volume_before = /** @type {(inputs: Ui_Volume_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before`)
};

const de_ui_volume_before = /** @type {(inputs: Ui_Volume_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Davor`)
};

/**
* | output |
* | --- |
* | "Before" |
*
* @param {Ui_Volume_BeforeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_volume_before = /** @type {((inputs?: Ui_Volume_BeforeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Volume_BeforeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_volume_before(inputs)
	return de_ui_volume_before(inputs)
});